import React from 'react';
import PropTypes from 'prop-types';
import { sanitizeId } from '../../utils/content-formatting';
import { ListItem, StyledLinkHandler, TileText, StyledSVG } from './styles';
import { propLink } from '../link-handler';
import iconSrc from '../../utils/iconSrc';
import { ButtonColorProps } from '../../prop-types';
import { VisuallyHidden } from '../styled/accessibility';

const TILE_COLORS = {
  Black: 'secondary-standard',
  White: 'secondary-outline',
  default: 'secondary-standard',
};

const Tile = ({ text, link, tileColor, dataTracking }) => {
  const tileId = sanitizeId(text).slice(0, 30);

  return (
    <ListItem>
      <StyledLinkHandler
        link={link}
        $bg={TILE_COLORS?.[tileColor] || TILE_COLORS.default}
        dataTracking={dataTracking}
      >
        <TileText id={`tile-heading-${tileId}`}>
          <VisuallyHidden>Read more on: </VisuallyHidden>
          {text}
        </TileText>
        <StyledSVG
          height="18"
          width="18"
          src={iconSrc('chevron-right')}
          aria-hidden="true"
        />
      </StyledLinkHandler>
    </ListItem>
  );
};

Tile.propTypes = {
  text: PropTypes.string.isRequired,
  tileColor: ButtonColorProps,
  link: propLink,
  dataTracking: PropTypes.string,
};

export default Tile;
